export default function Hero() {
  return (
    <section className="hero">
      <div className="container">
        <h1>Darbhanga's Premier RO Service Provider</h1>

        <p>
          Professional RO installation, repair, and maintenance services across India,
          offering nationwide coverage with guaranteed satisfaction, 24/7 support,
          and transparent pricing.
        </p>

        <div className="hero-actions">
          <a href="tel:8863093448" className="btn btn-accent">
            <i className="fas fa-phone"></i> Call Now: 8863093448
          </a>

          <a href="/services" className="btn btn-secondary">
            View Our Services
          </a>
        </div>
      </div>
    </section>
  );
}